import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

export default function SlidingDiv({ direction = "left", children }) {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.4,   // 20% of div visible triggers animation
  });

  const variants = {
    hidden: { x: direction === "left" ? -100 : 100, opacity: 0 },
    visible: { x: 0, opacity: 1 },
  };

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={variants}
      transition={{ duration: 0.7, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
}
